import { render, staticRenderFns } from "./InvoiceRemark.vue?vue&type=template&id=7d9159f2&scoped=true&"
import script from "./InvoiceRemark.vue?vue&type=script&lang=ts&"
export * from "./InvoiceRemark.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceRemark.vue?vue&type=style&index=0&id=7d9159f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9159f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VRow,VSheet})
